import React from 'react';
import { NavLink } from 'react-router-dom';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

var bnr1 = require('./../../images/background/bg-6.png');

class Specialization3 extends React.Component {
    state = {
        services: [],
        loading: true
    };

    componentDidMount() {
        axiosClient.get(apiConfig.SERVICES.GET_ALL)
            .then(res => {
                this.setState({ services: res.data.data.slice(0, 3), loading: false }); // Limit to 3 for this UI component
            })
            .catch(err => {
                console.error("Error fetching services", err);
                this.setState({ loading: false });
            });
    }

    render() {
        const { services, loading } = this.state;
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-dark mobile-page-padding" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
                    <div className="container">
                        <div className="section-content">
                            <div className="section-head m-b50 text-white text-center">
                                <h3 className="m-t0">Electro-mechanical Manufacturing and Installation Firm</h3>
                                <p>We focus in providing the latest innovations and technologies with quality that are affordable and user-friendly to our customers.</p>
                            </div>
                            <div className="row">
                                {loading ? (
                                    <div className="text-center text-white">Loading services...</div>
                                ) : (
                                    services.map((item, index) => (
                                        <div key={index} className={`col-md-4 m-b30 ${index === 2 ? 'col-sm-12' : 'col-sm-6'}`}>
                                            <div className="image-effect-one hover-shadow">
                                                <img src={item.image} alt={item.name} style={{ height: '300px', objectFit: 'cover' }} />
                                                <div className={`figcaption ${index === 2 ? 'bg-dark' : ''}`}>
                                                    <h4>{item.name}</h4>
                                                    <p>{(item.description || '').substring(0, 100)}...</p>
                                                    <NavLink to="/project-grid"><i className="link-plus bg-primary" /></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Specialization3;
